module.exports = __webpack_public_path__ + "img/zhyl32.c548addc.svg";